// React imports
import React from 'react';

// Third party imports
import { Button, Alert } from 'reactstrap';
import { toast } from 'react-toastify';
import axios from 'axios';

export default function PaymentUnderProcessNotifier({ underProcess, invoice_id, current_user, setLoading, last_payment_at }) {

  const handleButtonClick = (e, invoice_id) => {
    e.preventDefault();
    setLoading(true);
    axios.get(`/api/v1/admins/invoices/${invoice_id}/resend_payment_job`).then(res => {
      setLoading(false)
      toast.success(res?.data?.message)
    }).catch(err => {
      setLoading(false)
      toast.error(err?.response?.data?.message)
    })
  };

  // Only show Sync Invoice button after 5 minutes of last payment time
  const canSync = () => {
    if (!last_payment_at) return true;
    const lastPaymentTime = new Date(last_payment_at);
    const fiveMinutesLater = new Date(lastPaymentTime.getTime() + 5 * 60 * 1000);
    return new Date() >= fiveMinutesLater;
  };

  if (underProcess) {
    if (current_user?.is_admin && canSync()) {
      return (
        <div>
          <Alert color='primary' className='mb-3'>
            Some previous payments are not processed yet. Please click <Button color='danger' onClick={(e) => handleButtonClick(e, invoice_id)}>Sync Invoice</Button> to sync them with invoice provider.
          </Alert>
        </div>
      )
    }
    return (
      <div>
        <Alert color='primary' className='mb-3'>
          Last payment is being processed, please refresh the page after a minute to download the invoice.
        </Alert>
      </div>
    )
  }
  return (null);
}
